import styled from 'styled-components'

import Card from '../../../Card'
import breakpoints from '../../../../theme/breakpoints'
import FormErrors from '../../../form/FormErrors'
import FormSubmitButton from '../../../form/FormSubmitButton'
import FormFieldText from '../../../form/fields/FormFieldInput'
import FormikForm from '../../../form/FormikForm'

export const Container = styled.div<{ $background: string }>`
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1.6rem;
`

export const CardWrapper = styled(Card)``

export const Title = styled.h5`
  ${({ theme }) => theme.textStyles.H5};
  margin-bottom: 3.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
`

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 3.2rem;
  align-items: center;
  margin-bottom: 1rem;
`

export const FieldText = styled(FormFieldText)`
  width: 100%;

  min-width: 25rem;

  ${breakpoints.up('tablet')} {
    min-width: 37rem;
  }
`

export const Errors = styled(FormErrors)``

export const SubmitButton = styled(FormSubmitButton)`
  display: block;
  margin: 3.6rem auto 3.2rem auto;
`
